import { FaSearchPlus } from 'react-icons/fa';
import { Modal } from 'components';
import * as S from './styles';

interface Props {
  src: string;
  alt: string;
}

export function Image({ src, alt }: Props) {
  const image = <S.Image src={src} alt={alt} />;

  return (
    <Modal modalContent={image}>
      <S.Figure>
        {image}

        <S.Icon>
          <FaSearchPlus />
        </S.Icon>
      </S.Figure>
    </Modal>
  );
}
